import { Link } from "react-router-dom";

export default function OnDemandSection() {
  return (
    <section className="cl-ondemand" aria-labelledby="ondemand-title">
      <div className="cl-container cl-ondemand-inner">
        <p className="cl-eyebrow center">On Demand</p>
        <h2 id="ondemand-title" className="cl-ondemand-title">
        For one-time legal support, complex matters, or tailored legal assistance.
        </h2>
        <Link to="/contact" className="btn-ondemand">
        Let’s discuss
        </Link>
      </div>
    </section>
  );
}
